import {
    useEffect
} from 'react';

export function useUpdateShellPrimary(navigationTitle, navigationComponents) {
    useEffect(() => {
        let title = navigationTitle;
        if (_.isFunction(title)) {
            title = title();
        }
        RivalIQ.apps.Shell.execute('set:primary', title, navigationComponents);

        RivalIQ.curation.timePeriod = navigationComponents.timePeriod;
    }, [navigationTitle, navigationComponents]);
}

export function useUpdateShellSecondary(showSecondaryNavigation, secondaryNavigationOptions) {
    useEffect(() => {

        if (showSecondaryNavigation) {
            RivalIQ.apps.Shell.execute('set:navigation', secondaryNavigationOptions);
        } else {
            // Both of these calls are necessary to hide the secondary navigation.
            RivalIQ.apps.Shell.execute('hide:navigation');
            RivalIQ.apps.Shell.execute('set:navigation', {});
        }

    }, [showSecondaryNavigation, secondaryNavigationOptions]);
}

const alert = (type, message, options) => {
    requestAnimationFrame(() => {
        RivalIQ.execute(`alert:${type}`, message, options);
    });
};

export function useShellAlert() {
    return _.reduce(RivalIQ.apps.Shell.views.Alert.type, (memo, value) => {
        return _.set(memo, value, _.partial(alert, value));
    }, {alert}); // eslint-disable-line object-curly-newline
}
